import axios from "axios";

export default class ApiService {
    // static BASE_URL = "http://13.51.72.202:8081";

    static BASE_URL = "https://server.vila-l.com";


    static getHeader() {
        const token = localStorage.getItem("token");
        if (!token) {
            console.warn("No token found in localStorage");
        } else {
            console.log("Retrieved token:", token); 
        }
        return {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };
    }

    static async loginUser(loginDetails) {
        try {
            const response = await axios.post(`${this.BASE_URL}/user/login`, loginDetails);
            
            // Store the received data in localStorage
            const { token, userId, username, email, roles } = response.data;
            localStorage.setItem("token", token);
            localStorage.setItem("userId", userId);
            localStorage.setItem("username", username);
            localStorage.setItem("email", email);
            localStorage.setItem("role", JSON.stringify(roles.map(role => role.role))); 

            console.log("Token set in localStorage:", token);
            return response;
        } catch (error) {
            console.error("Error logging in:", error);
            throw error;
        }
    }

    //Project api Admin

    static async createProject(formData) {
        try {
            const form = new FormData();
            form.append('projectType', formData.projectType);
            form.append('projectTitle', formData.projectTitle);
            form.append('titulliProjekti', formData.titulliProjekti);
            form.append('projectAddress', formData.projectAddress);
            form.append('adresaProjekti', formData.adresaProjekti);
            form.append('projectDescription', formData.projectDescription);
            form.append('pershkrimiProjekti', formData.pershkrimiProjekti);
            form.append('boxOne', formData.boxOne);
            form.append('boxTwo', formData.boxTwo);
            form.append('boxThree', formData.boxThree);
            form.append('boxFour', formData.boxFour);
            form.append('boxFive', formData.boxFive);
            form.append('boxSix', formData.boxSix);
            form.append('boxSeven', formData.boxSeven);
            form.append('boxEight', formData.boxEight);
            
            if (formData.projectImageUrl) {
                form.append('projectImageUrl', formData.projectImageUrl);
            }


            const response = await axios.post(
                `${this.BASE_URL}/projects/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async updateProject(projectId, formData) {
        try {
            const form = new FormData();
            form.append('projectType', formData.projectType);
            form.append('projectTitle', formData.projectTitle);
            form.append('titulliProjekti', formData.titulliProjekti);
            form.append('projectAddress', formData.projectAddress);
            form.append('adresaProjekti', formData.adresaProjekti);
            form.append('projectDescription', formData.projectDescription);
            form.append('pershkrimiProjekti', formData.pershkrimiProjekti);
            form.append('boxOne', formData.boxOne);
            form.append('boxTwo', formData.boxTwo);
            form.append('boxThree', formData.boxThree);
            form.append('boxFour', formData.boxFour);
            form.append('boxFive', formData.boxFive);
            form.append('boxSix', formData.boxSix);
            form.append('boxSeven', formData.boxSeven);
            form.append('boxEight', formData.boxEight);
            
            if (formData.projectImageUrl) {
                form.append('projectImageUrl', formData.projectImageUrl);
            }


            const response = await axios.put(
                `${this.BASE_URL}/projects/update/${projectId}`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
      }

    static async getAllMiniProjects(){
        const response = await axios.get(`${this.BASE_URL}/projects/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getAllProjects(){
        const response = await axios.get(`${this.BASE_URL}/projects/get/all`,);
        return response.data;
    }

    static async getAllProjectsRandom() {
        const response = await axios.get(`${this.BASE_URL}/projects/get/all/random`);
        console.log(response.data); // Debug
        return response.data;
    }
    

    static async getSingleProject(projectId){
        const response = await axios.get(`${this.BASE_URL}/projects/get/single/project/${projectId}` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getOneProject(projectId){
        const response = await axios.get(`${this.BASE_URL}/projects/get/single/project/${projectId}` ,);
        return response.data;
    }

    

    static async deleteProject(projectId){
        const response = await axios.delete(`${this.BASE_URL}/projects/delete/${projectId}` , 
            {
                headers: {
                    ...this.getHeader(),
                    // "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response;
    }

    //Project api Admin End

    //SalesCategory api Admin

    static async getAllMiniSalesCategory(){
        const response = await axios.get(`${this.BASE_URL}/salescategory/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getAllMiniSalesCategoryPublic(){
        const response = await axios.get(`${this.BASE_URL}/salescategory/get/mini` ,);
        return response.data;
    }

    static async getSingleSalesCategory(categoryId){
        const response = await axios.get(`${this.BASE_URL}/salescategory/get/single/category/${categoryId}` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async createSalesCategory(formData) {
        try {
            const form = new FormData();
            form.append('categoryName', formData.categoryName);
            form.append('emriKategorise', formData.emriKategorise);

            const response = await axios.post(
                `${this.BASE_URL}/salescategory/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async updateSalesCategory(categoryId, formData) {
        try {
            const form = new FormData();
            form.append('categoryName', formData.categoryName);
            form.append('emriKategorise', formData.emriKategorise);
            
            const response = await axios.put(
                `${this.BASE_URL}/salescategory/update/${categoryId}`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
      }

    static async deleteSalesCategory(categoryId){
        const response = await axios.delete(`${this.BASE_URL}/salescategory/delete/${categoryId}` , 
            {
                headers: {
                    ...this.getHeader(),
                    // "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response;
    }

    //sales category api end

    //staff api 

    static async getAllMiniStaff(){
        const response = await axios.get(`${this.BASE_URL}/staff/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getAllStaffPublic(){
        const response = await axios.get(`${this.BASE_URL}/staff/get/mini` , );
        return response.data;
    }

    static async getSingleStaff(staffId){
        const response = await axios.get(`${this.BASE_URL}/staff/get/single/staff/${staffId}` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getSingleStaffPublic(staffId){
        const response = await axios.get(`${this.BASE_URL}/staff/get/single/staff/${staffId}` , );
        return response.data;
    }

    static async createStaff(formData) {
        try {
            const form = new FormData();
            form.append('staffTittle', formData.staffTittle);
            form.append('titulliStaf', formData.titulliStaf);
            form.append('staffDescriptionOne', formData.staffDescriptionOne);
            form.append('pershkrimiStafNje', formData.pershkrimiStafNje);
            form.append('staffDescriptionTwo', formData.staffDescriptionTwo);
            form.append('pershkrimiStafDy', formData.pershkrimiStafDy);
            
            const response = await axios.post(
                `${this.BASE_URL}/staff/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async updateStaff(staffId, formData) {
        try {
            const form = new FormData();
            form.append('staffTittle', formData.staffTittle);
            form.append('titulliStaf', formData.titulliStaf);
            form.append('staffDescriptionOne', formData.staffDescriptionOne);
            form.append('pershkrimiStafNje', formData.pershkrimiStafNje);
            form.append('staffDescriptionTwo', formData.staffDescriptionTwo);
            form.append('pershkrimiStafDy', formData.pershkrimiStafDy);
            
            const response = await axios.put(
                `${this.BASE_URL}/staff/update/${staffId}`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
      }

    static async deleteStaff(staffId){
        const response = await axios.delete(`${this.BASE_URL}/staff/delete/${staffId}` , 
            {
                headers: {
                    ...this.getHeader(),
                },
            }
        );
        return response;
    }

    //staff api end

    //news api

    static async getAllMiniNews(){
        const response = await axios.get(`${this.BASE_URL}/news/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getAllMiniNewsPublic(){
        const response = await axios.get(`${this.BASE_URL}/news/get/mini` , );
        return response.data;
    }

    static async getSingleNews(newsId){
        const response = await axios.get(`${this.BASE_URL}/news/get/single/news/${newsId}` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getSingleNewsPublic(newsId){
        const response = await axios.get(`${this.BASE_URL}/news/get/single/news/${newsId}`,);
        return response.data;
    }

    static async createNews(formData) {
        try {
            const form = new FormData();
            form.append('newsType', formData.newsType);
            form.append('newsTitle', formData.newsTitle);
            form.append('titullLajmesh', formData.titullLajmesh);
            form.append('newsDescription', formData.newsDescription);
            form.append('pershkrimLajmesh', formData.pershkrimLajmesh);
            
            if (formData.newsImageUrl) {
                form.append('newsImageUrl', formData.newsImageUrl);
            }

            const response = await axios.post(
                `${this.BASE_URL}/news/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async updateNews(newsId, formData) {
        try {
            const form = new FormData();
            form.append('newsType', formData.newsType);
            form.append('newsTitle', formData.newsTitle);
            form.append('titullLajmesh', formData.titullLajmesh);
            form.append('newsDescription', formData.newsDescription);
            form.append('pershkrimLajmesh', formData.pershkrimLajmesh);
            
            if (formData.newsImageUrl) {
                form.append('newsImageUrl', formData.newsImageUrl);
            }

            const response = await axios.put(
                `${this.BASE_URL}/news/update/${newsId}`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
      }



    static async deleteNews(newsId){
        const response = await axios.delete(`${this.BASE_URL}/news/delete/${newsId}` , 
            {
                headers: {
                    ...this.getHeader(),
                },
            }
        );
        return response;
    }

    //news api end

    //building api 

    static async getAllMiniBuilding(){
        const response = await axios.get(`${this.BASE_URL}/building/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getAllMiniBuildingPublic(){
        const response = await axios.get(`${this.BASE_URL}/building/get/mini` , );
        return response.data;
    }

    static async getAllMiniBuildingPublicRandom(){
        const response = await axios.get(`${this.BASE_URL}/building/get/mini/random` , );
        return response.data;
    }

    static async getSingleBuilding(buildingId){
        const response = await axios.get(`${this.BASE_URL}/building/get/single/building/${buildingId}` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getSingleBuildingPublic(buildingId){
        const response = await axios.get(`${this.BASE_URL}/building/get/single/building/${buildingId}`,);
        return response.data;
    }

    static async createBuilding(formData) {
        try {
            const form = new FormData();
            form.append('buildingTitle', formData.buildingTitle);
            form.append('buildingAdress', formData.buildingAdress);
            form.append('titulliNderteses', formData.titulliNderteses);
            form.append('adresaNderteses', formData.adresaNderteses);
            form.append('buildingGoogleLink', formData.buildingGoogleLink);
            
            if (formData.buildingImageUrl) {
                form.append('buildingImageUrl', formData.buildingImageUrl);
            }

            if (formData.buildingGoogleAdressImageUrl) {
                form.append('buildingGoogleAdressImageUrl', formData.buildingGoogleAdressImageUrl);
            }

            if (formData.buildingApartmentImageUrl) {
                form.append('buildingApartmentImageUrl', formData.buildingApartmentImageUrl);
            }

            if (formData.buildingServiceImageUrl) {
                form.append('buildingServiceImageUrl', formData.buildingServiceImageUrl);
            }

            if (formData.buildingPostImageUrl) {
                form.append('buildingPostImageUrl', formData.buildingPostImageUrl);
            }


            const response = await axios.post(
                `${this.BASE_URL}/building/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async updateBuilding(buildingId, formData) {
        try {
            const form = new FormData();
    
            // Append text fields
            form.append('buildingTitle', formData.buildingTitle || "");
            form.append('buildingAdress', formData.buildingAdress || "");
            form.append('titulliNderteses', formData.titulliNderteses || "");
            form.append('adresaNderteses', formData.adresaNderteses || "");
            form.append('buildingGoogleLink', formData.buildingGoogleLink || "");
    
            // Append only valid file fields
            const fileFields = [
                "buildingImageUrl",
                "buildingGoogleAdressImageUrl",
                "buildingApartmentImageUrl",
                "buildingServiceImageUrl",
                "buildingPostImageUrl"
            ];
    
            fileFields.forEach((field) => {
                if (formData[field] instanceof File) {
                    form.append(field, formData[field]);
                }
            });
    
            // Debugging: Log form data before sending
            for (let [key, value] of form.entries()) {
                console.log(key, value);
            }
    
            const response = await axios.put(
                `${this.BASE_URL}/building/update/${buildingId}`, 
                form,
                {
                    headers: this.getHeader(), // Axios automatically sets multipart boundary
                }
            );
    
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }
    

    static async deleteBuilding(buildingId){
        const response = await axios.delete(`${this.BASE_URL}/building/delete/${buildingId}` , 
            {
                headers: {
                    ...this.getHeader(),
                },
            }
        );
        return response;
    }

    //building api end

    //salescatalog api

    static async getAllMiniSalesCatalog(){
        const response = await axios.get(`${this.BASE_URL}/catalog/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getAllSales(){
        const response = await axios.get(`${this.BASE_URL}/catalog/get/mini` ,);
        return response.data;
    }

    static async getAllSalesRandom(){
        const response = await axios.get(`${this.BASE_URL}/catalog/get/mini/random` ,);
        return response.data;
    }

    static async getAllCatalogPublic(buildingId, categoryId){
        const response = await axios.get(`${this.BASE_URL}/catalog/get/catalog/${buildingId}/${categoryId}`,);
        return response.data;
    }

    static async getSingleSales(catalogId){
        const response = await axios.get(`${this.BASE_URL}/catalog/get/single/catalog/${catalogId}`, 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async createSalesCatalog(formData) {
        try {
            const form = new FormData();
            form.append('catalogTitle', formData.catalogTitle);
            form.append('titulliKatalog', formData.titulliKatalog);
            form.append('catalogDescription', formData.catalogDescription);
            form.append('pershkrimKatalog', formData.pershkrimKatalog);
            form.append('salesCategoryId', formData.salesCategoryId);
            form.append('buildingId', formData.buildingId);
            form.append('pdfLayout', formData.pdfLayout);
            if (formData.catalogImageUrl) {
                form.append('catalogImageUrl', formData.catalogImageUrl);
            }

            if (formData.pdfUrl) {
                form.append('pdfUrl', formData.pdfUrl);
            }

            const response = await axios.post(
                `${this.BASE_URL}/catalog/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async updateSalesCatalog(catalogId, formData) {
        try {
            const form = new FormData();
            form.append('catalogTitle', formData.catalogTitle);
            form.append('titulliKatalog', formData.titulliKatalog);
            form.append('catalogDescription', formData.catalogDescription);
            form.append('pershkrimKatalog', formData.pershkrimKatalog);
            form.append('salesCategoryId', formData.salesCategoryId);
            form.append('buildingId', formData.buildingId);
            form.append('pdfLayout', formData.pdfLayout);
            if (formData.catalogImageUrl) {
                form.append('catalogImageUrl', formData.catalogImageUrl);
            }

            if (formData.pdfUrl) {
                form.append('pdfUrl', formData.pdfUrl);
            }

            const response = await axios.put(
                `${this.BASE_URL}/catalog/update/${catalogId}`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
      }

    

    static async deleteSalesCatalog(catalogId){
        const response = await axios.delete(`${this.BASE_URL}/catalog/delete/${catalogId}` , 
            {
                headers: {
                    ...this.getHeader(),
                },
            }
        );
        return response;
    }

    //salescatalog api end

    //gallery api

    static async getAllMiniGalleries(){
        const response = await axios.get(`${this.BASE_URL}/gallery/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getSingleContact(contactId){
        const response = await axios.get(`${this.BASE_URL}/contact/get/single/contact/${contactId}`, 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getGalleryOneProject(projectId){
        const response = await axios.get(`${this.BASE_URL}/gallery/get/mini/${projectId}` ,);
        return response.data;
    }

    static async getGalleryOneRandom(){
        const response = await axios.get(`${this.BASE_URL}/gallery/get/random` ,);
        return response.data;
    }

    
    static async createGallery(formData) {
        try {
            const form = new FormData();
            form.append('projectId', formData.projectId);    
            if (formData.galleryImageUrl) {
                form.append('galleryImageUrl', formData.galleryImageUrl);
            }
            const response = await axios.post(
                `${this.BASE_URL}/gallery/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async deleteGallery(galleryId){
        const response = await axios.delete(`${this.BASE_URL}/gallery/delete/${galleryId}` , 
            {
                headers: {
                    ...this.getHeader(),
                },
            }
        );
        return response;
    }

    //newsimage api

    static async getAllMiniNewsImage(){
        const response = await axios.get(`${this.BASE_URL}/newsimage/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async getNewsImageOneProject(newsId){
        const response = await axios.get(`${this.BASE_URL}/newsimage/get/mini/${newsId}` ,);
        return response.data;
    }

    static async getNewsImageOneRandom(){
        const response = await axios.get(`${this.BASE_URL}/newsimage/get/random`);
        return response.data;
    }

    static async createNewsImage(formData) {
        try {
            const form = new FormData();
            form.append('newsId', formData.newsId);    
            if (formData.newsImageUrl) {
                form.append('newsImageUrl', formData.newsImageUrl);
            }
            const response = await axios.post(
                `${this.BASE_URL}/newsimage/save`, 
                form,
                {
                    headers: {
                        ...this.getHeader(),
                        "Content-Type": "multipart/form-data", 
                    },
                }
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }

    static async deleteNewsImage(newsId){
        const response = await axios.delete(`${this.BASE_URL}/newsimage/delete/${newsId}` , 
            {
                headers: {
                    ...this.getHeader(),
                },
            }
        );
        return response;
    }


    //contact api

    static async getAllMiniContacts(){
        const response = await axios.get(`${this.BASE_URL}/contact/get/mini` , 
            {
                headers: {
                    ...this.getHeader(),
                    "Content-Type": "multipart/form-data", 
                },
            }
        );
        return response.data;
    }

    static async createContact(formData) {
        try {
            const form = new FormData();
            form.append('firstName', formData.firstName);
            form.append('lastName', formData.lastName);
            form.append('email', formData.email);
            form.append('contactNumber', formData.contactNumber);
            form.append('contactMessage', formData.contactMessage);
            if (formData.cvUrl) {
                form.append('cvUrl', formData.cvUrl);
            }


            const response = await axios.post(
                `${this.BASE_URL}/contact/save`, 
                form
            );
            return response;
        } catch (error) {
            console.error("Error submitting form:", error);
            throw error;
        }
    }
    

    static isAuthenticated() {
        const token = localStorage.getItem("token");
        return !!token; // Returns true if token exists
    }

    static isAdmin() {
        const roles = JSON.parse(localStorage.getItem("role")); // Parse the stored JSON string
        return roles && roles.includes("ROLE_ADMIN"); // Check if 'ROLE_ADMIN' is in the roles array
    }

    static isUser() {
        const roles = JSON.parse(localStorage.getItem("role")); // Parse the stored JSON string
        const userId = JSON.parse(localStorage.getItem("userId"));
        return roles && roles.includes("ROLE_USER") && userId; // Check if 'ROLE_USER' is in the roles array
    }
}